import React from "react";
import "../styles/TransposTopBar.css";
import { useGame } from "../GameContext";
const TopBar: React.FC = () => {
  const { message, setHelpPanelOpen } = useGame();
  return (
      <div className="transpos-top-bar">
        <a className="transpos-logo" href="https://kotobot.app/index.html">
          <img
            className="transpos-logo"
               title ="На главную"
            src="/img/kotobot.svg"
            alt="Kotobot logo"
          />
        </a>
        <div className="transpos-message-bar">{message}</div>
        <img
          className="transpos-icon"
          id = "transpos-help-icon"
          alt="Помощь"
          src="/img/help-fix.svg"
          title="Помощь"
          onClick={() => setHelpPanelOpen(true)}
        />
      </div>
  );
};

export default TopBar;
